import { GraphQLClient } from 'graphql-request'
import { getInstance } from '@/auth'

export default {
  async request(...args) {
    let instance = getInstance()
    let token

    try {
      token = await instance.getTokenSilently()
    } catch (err) {}

    return new GraphQLClient(process.env.VUE_APP_API + '/graphql', {
      headers: {
        'accept-language': sessionStorage.getItem('lang'),
        authorization: token ? 'Bearer ' + token : undefined,
        'array-strategy': 'diff',
      },
    }).request(...args)
  },
}
